import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const InvitationsApi = {
  createInvite(data) {
    return http.post(`${teamPath()}/invitations`, data).then((response) => response.data.data);
  },
};
